import { Square } from "@mui/icons-material";
import React from "react";

const getShiftStyle = (shift: string) => {
	if (shift === "D") {
		return { color: "#52a8b7" };
	} else if (shift === "N") {
		return { color: "#A5A5A5" };
	} else {
		return {};
	}
};

const getCrewStyle = (crew: string) => {
	if (crew === "A") {
		return { color: "#0070C0" };
	} else if (crew === "B") {
		return { color: "#FFD24A" };
	} else if (crew === "C") {
		return { color: "#FD8359" };
	} else if (crew === "D") {
		return { color: "#00B050" };
	} else {
		return {};
	}
};
const GetShiftColor = (props: any) => {
	return (
		<React.Fragment>
			<Square sx={{ mr: 1, ...getShiftStyle(props.value) }} fontSize="small" />
		</React.Fragment>
	);
};
const GetCrewColor = (props: any) => {
	return (
		<React.Fragment>
			<Square sx={{ mr: 1, ...getCrewStyle(props.value) }} fontSize="small" />
		</React.Fragment>
	);
};

export { getShiftStyle, getCrewStyle, GetShiftColor, GetCrewColor };
